<template>
  <NuxtLink
      :class="{'is-rare': !isRare, 'not-rare': isRare}"
      :style="{'--background-image': `url(${getImagePath()})`}"
      :to="localePath(getLink())"
      class="card card-dark multicard"
  >
    <div class="multicard__images">
      <img
          :key="items[currentIndex]"
          :alt="items[currentIndex]"
          :src="getImageFromWaxpeer(items[currentIndex], '200:200')"
          class="multicard__image"
          height="100"
          loading="lazy"
          width="150"
      >
    </div>
    <div>
      <div class="hr mt8 mb8"></div>
      <p :class="{'is-rare': !isRare}" class="multicard__title">
        {{ t(isRare ? 'regular_items' : 'rare_special_items') }}
      </p>
    </div>
    <div>
      <div class="hr mt8 mb8"></div>
      <p class="multicard__count">
        {{
          t('possibly_items', {
            name: t(category === 'Normal' ? 'Skins' : `filters.weapon.${category}`),
            count: items.length
          })
        }}
      </p>
    </div>

  </NuxtLink>
</template>

<script lang="ts" setup>
import {ref} from 'vue'

const props = defineProps<{
  items: string[]
  category: "Knives" | "Gloves" | "Normal"
  isRare?: boolean
}>()
const route = useRoute()
const localePath = useLocalePath()
const {t} = useI18n()

const currentIndex = ref<number>(0)

const getLink = () => {
  if (props.isRare) {
    return `/containers/${route.params.id}`
  }
  return `/containers/${route.params.id}/rare-items`
}

const getImagePath = () => {
  return props.isRare ? `/images/cases/${route.params.id}.webp` : '/img/rare-item.webp';
};

if (process.client) {
  setInterval(() => {
    currentIndex.value = props.items?.slice(-6)?.length <= currentIndex.value ? 0 : currentIndex.value + 1
  }, 2500)
}
</script>

<style lang="scss" scoped>


.multicard {
  display: flex;
  flex-direction: column;
  text-align-last: center;
  color: var(--surfaces-on-surface);
  padding: 0.8rem 0.8rem 1.2rem;
  position: relative;
  background: radial-gradient(at left top, #46BFC940, #11141A80, #9080F940);

  &.is-rare:after, &.not-rare:after {
    content: '';
    display: block;
    position: absolute;
    inset: 0 20px;
    background-image: var(--background-image);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center 35%;
    opacity: 0.09;
    max-width: 300px;
    margin: 0 auto;
  }

  &__images {
    margin: auto 0;
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    min-height: 300px;
  }

  &__title {
    font-weight: 800;
    font-size: 1.6rem;
    padding: 12px 0;
    text-align: center;

    &.is-rare {
      color: var(--souvenir);
    }
  }

  &__count {
    font-weight: 600;
    font-size: 1.6rem;
    text-align: center;
  }

  &__image {
    width: 70%;
    height: auto;
    object-fit: contain;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: fadeIn 2.5s ease forwards;
    max-height: 150px;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    width: 0;
  }
  25%, 75% {
    opacity: 1;
    transform: translate(-50%, -50%) rotate(720deg);
    width: 70%;
  }
  100% {
    opacity: 0;
    width: 0;
  }
}

.custom-animate-enter-active, .custom-animate-leave-active {
  transition: all 1s;
  opacity: 1;
}

.custom-animate-enter, .custom-animate-leave-to /* .custom-animate-leave-active в версии <2.1.8 */
{
  width: 0;
  opacity: 0;
  transform: translate(-50%, -50%) rotate(360deg);
}
</style>
